import React from 'react'
import { useTranslation } from 'react-i18next'

import { FormikProvider } from 'formik'
import { Grid, Box, Button } from '@mui/material'
import { useSportsROCalculatorFilters } from '@/views/sports-ro-calculator/hooks'

import {
  MaxLineFilterType,
  MinLineFilterType,
  RolloverAmountCalculationFilterType,
  SportsRODateRangeFilterType,
  SportsFilterType,
  WagerTypesFilterType,
  UsernameFilterType,
} from './'

export const SportsROCalculatorFiltersComponent = () => {
  const { t } = useTranslation()

  const { formikSportsRO, handleChangeSearch, submitSearchFilter } =
    useSportsROCalculatorFilters()

  return (
    <FormikProvider value={formikSportsRO}>
      <Box pb={2}>
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={12} md={3} lg={2}>
            <UsernameFilterType handleChangeSearch={handleChangeSearch} />
          </Grid>
          <SportsRODateRangeFilterType
            handleChangeSearch={handleChangeSearch}
          />
          <Grid item xs={12} md={3} lg={2}>
            <SportsFilterType handleChangeSearch={handleChangeSearch} />
          </Grid>
          <Grid item xs={12} md={3} lg={2}>
            <WagerTypesFilterType handleChangeSearch={handleChangeSearch} />
          </Grid>
          <Grid item xs={12} md={3} lg={1.5}>
            <MinLineFilterType handleChangeSearch={handleChangeSearch} />
          </Grid>
          <Grid item xs={12} md={3} lg={1.5}>
            <MaxLineFilterType handleChangeSearch={handleChangeSearch} />
          </Grid>
          <Grid item xs={12} md={3} lg={2}>
            <RolloverAmountCalculationFilterType
              handleChangeSearch={handleChangeSearch}
            />
          </Grid>
          <Grid item xs={12} md={4} lg={1}>
            <Box p={0.5} mt={1}>
              <Button
                variant="contained"
                color="primary"
                onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) =>
                  submitSearchFilter()
                }
                disabled={!(formikSportsRO.isValid && formikSportsRO.dirty)}
              >
                {t('search')}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </FormikProvider>
  )
}
